import { render, staticRenderFns } from "./s05-risks.vue?vue&type=template&id=d93acb08&scoped=true"
import script from "./s05-risks.vue?vue&type=script&lang=js"
export * from "./s05-risks.vue?vue&type=script&lang=js"
import style0 from "./s05-risks.vue?vue&type=style&index=0&id=d93acb08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d93acb08",
  null
  
)

export default component.exports